export default __webpack_public_path__ + "static/media/twitter.b901e592.svg";